export const ICON_NAMESPACE = 'es-fields';
